import { render, staticRenderFns } from "./UpdateInstitutionCharge.vue?vue&type=template&id=1691e35d"
import script from "./UpdateInstitutionCharge.vue?vue&type=script&lang=js"
export * from "./UpdateInstitutionCharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports